//import 'bootstrap/dist/css/bootstrap.min.css';
import ReactDOM from "react-dom/client";
import {BrowserRouter as Router, Routes, Route, Link} from 'react-router-dom';
//import * as bootstrap from 'bootstrap';

import Login from "./pages/Login";
import Dashboard from './pages/Dashboard';
import SummaryDashboardPage from './pages/SummaryDashboard/SummaryDashboardPage';
import Listings from './pages/Listings';
import AIAssistant from './pages/AIAssistant';
//import Analysis from './pages/Analysis';
import PrivateRoute from "./components/PrivateRoute";
import Navigationbar from './components/Navigationbar';
import Footer from './components/Footer';

const year = new Date().getFullYear();

function App() {
  return (
    <div className="App min-vh-100 d-flex flex-column">
      <Router>
           <Navigationbar />
           <Routes>
               <Route path="/login" element={<Login />} />
               <Route path="/" element={
                         <PrivateRoute>
                           <Dashboard />
                         </PrivateRoute>
                       } />
               <Route path="/summary-dashboard" element={
                                 <PrivateRoute>
                                   <SummaryDashboardPage />
                                 </PrivateRoute>
                               } />
               <Route path="/listings" element={
                         <PrivateRoute>
                           <Listings />
                         </PrivateRoute>
               } />
               <Route path="/ai-assistant" element={
                         <PrivateRoute>
                           <AIAssistant />
                         </PrivateRoute>
               } />
           </Routes>
           <Footer />
      </Router>
    </div>
     );
}

export default App;
